<template>
   <div style="width: 100%;height: 100%">
     <EducateNormal type="1"/>
   </div>
</template>
<script>
import EducateNormal from './educateNormal.vue';
export default {
   name: '',
   components: {
     EducateNormal
   },
   mixins: [],
   props: {
     
   },
   data() {
     return {
       
     }
   },
   computed: {
     
   },
   watch: {
     
   },
   mounted() {
   },
   methods: {
     
   }
};
</script>
<style lang='scss' scoped>
</style>